import React, { Component } from 'react';
import ReisadviezenFlex from "../components/Reisadviezen/Flex";
import dynamicPortal from '../utils/dynamicPortal';

export class ReisadviezenFlexPortal extends Component {
  render() {
    return dynamicPortal.load('.js-react-reisadviezen-flex', (config) => (
      <ReisadviezenFlex config={config} />
    ))
  }
}

export default ReisadviezenFlexPortal;


// WEBPACK FOOTER //
// ./src/portals/ReisadviezenFlexPortal.js